import React from 'react';
import './Address.css';

const Address = ({ project }) => {
  return (
    <div className="address-container">
      <div className="section-header">
        <h3>Address</h3>
        <p>Location and address information</p>
      </div>
      
      <div className="address-info">
        <div className="info-item">
          <label>Address</label>
          <input type="text" placeholder="Enter project address" />
        </div>
        <div className="info-item">
          <label>Coordinates</label>
          <div className="coordinate-inputs">
            <input type="text" placeholder="Latitude" />
            <input type="text" placeholder="Longitude" />
          </div>
        </div>
      </div>
      
      <div className="map-actions">
        <button className="action-btn">
          <i className="fas fa-map-marker-alt"></i>
          <span>Set Location</span>
        </button>
      </div>
    </div>
  );
};

export default Address;
